import { useNavigate } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { ThemedLogo } from "@/components/ThemedLogo";
import { Mail, MapPin, Building2, Trophy, DollarSign } from "lucide-react";
import { ROUTES } from "@/lib/routes";

export const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="border-t bg-background mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div className="md:col-span-1">
            <ThemedLogo className="h-10 w-auto mb-4" />
            <p className="text-sm text-muted-foreground">
              Plataforma completa para gestão de arenas esportivas, torneios e controle financeiro.
            </p>
          </div>

          {/* Soluções */}
          <div>
            <h3 className="font-semibold mb-4">Soluções</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <button 
                  onClick={() => navigate("/solucao/arenas")} 
                  className="flex items-center gap-2 hover:text-primary transition-colors"
                >
                  <Building2 className="w-4 h-4" />
                  Gestão de Arenas
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate("/solucao/torneios")} 
                  className="flex items-center gap-2 hover:text-primary transition-colors"
                >
                  <Trophy className="w-4 h-4" />
                  Gestão de Torneios
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate("/solucao/erp-financeiro")} 
                  className="flex items-center gap-2 hover:text-primary transition-colors"
                >
                  <DollarSign className="w-4 h-4" />
                  ERP Financeiro
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate(ROUTES.TOOLS)}
                  className="flex items-center gap-2 hover:text-primary transition-colors"
                >
                  <Trophy className="w-4 h-4" />
                  Ferramentas grátis
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <button onClick={() => navigate("/termos-de-uso")} className="hover:text-primary transition-colors">
                  Termos de Uso
                </button>
              </li>
              <li>
                <button onClick={() => navigate("/politica-de-reembolso")} className="hover:text-primary transition-colors">
                  Política de Reembolso
                </button>
              </li>
              <li>
                <button onClick={() => navigate("/politica-de-privacidade")} className="hover:text-primary transition-colors">
                  Política de Privacidade
                </button>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="font-semibold mb-4">Contato</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <a href="mailto:contato@vellosports.com.br" className="hover:text-primary transition-colors">
                  contato@vellosports.com.br
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Presidente Epitácio, SP</span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} VelloPlay. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};
